import { Injectable } from '@angular/core';
import { environment } from "../environments/environment";
import { Http, Response, ResponseContentType } from "@angular/http";
import { Observable } from "rxjs/Observable"
import { AuthHttp } from 'angular2-jwt';

import "rxjs/add/operator/map";

@Injectable()
export class VerifyBonusCalculationApiService {

  constructor(private verifyBonusCalculationApi : AuthHttp) { }

  GetYearDropdown() {
    return this.verifyBonusCalculationApi.get(environment.apiEndPoint + '/GetListReportYear')
      .map((response: Response) => response.json())
  }

  GetDataDealer(Year,Quartal,ID) {
    return this.verifyBonusCalculationApi.get(environment.apiEndPoint + '/Bonus/'+Year+'/'+ Quartal+ '/'+ ID).map((response: Response) => response.json());
  }

  GetDataDealerDetail(ID){
    return this.verifyBonusCalculationApi.get(environment.apiEndPoint + '/Bonus/' + ID).map((response: Response) => response.json());
  }

  PostVerifyBonusDetail(formData)
  {
    return this.verifyBonusCalculationApi.post(environment.apiEndPoint + '/Bonus/Approval',formData).map((response: Response) => response.json());
  }

}



// WEBPACK FOOTER //
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/src/data/VerifyBonusCalculationApi.service.ts